import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

export interface SegmentedToggleOption {
  label: string;
  value: any;
  icon?: string;
  iconColor?: string;
  iconHtml?: string;
}

export type SegmentedToggleSize = 'small' | 'medium' | 'large';
export type SegmentedToggleVariant = 'primary' | 'secondary';

@Component({
  selector: 'app-segmented-toggle',
  templateUrl: './segmented-toggle.component.html',
  styleUrls: ['./segmented-toggle.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SegmentedToggleComponent),
      multi: true
    }
  ]
})

export class SegmentedToggleComponent implements ControlValueAccessor {
  @Input() options: SegmentedToggleOption[] = [];
  @Input() value: any;
  @Input() disabled: boolean = false;
  @Input() size: SegmentedToggleSize = 'medium';
  @Input() variant: SegmentedToggleVariant = 'primary';
  @Input() fullWidth: boolean = false;

  @Output() valueChange = new EventEmitter<any>();

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  onSelect(option: SegmentedToggleOption): void {
    if (!this.disabled) {
      this.value = option.value;
      this.valueChange.emit(option.value);
      this.onChange(option.value);
    }
  }

  isSelected(option: SegmentedToggleOption): boolean {
    return this.value === option.value;
  }

  trackByValue(_index: number, option: SegmentedToggleOption): any {
    return option.value;
  }

    constructor(private sanitizer: DomSanitizer) {}
  get segmentedClasses(): string {
    const classes = [
      `toggle-${this.size}`,
      `toggle-${this.variant}`
    ];
    if (this.disabled) classes.push('toggle-disabled');
    if (this.fullWidth) classes.push('toggle-full-width');
    return classes.join(' ');
  }

  // ControlValueAccessor implementation
  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
    htmlProperty(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}

